// =============================================================================
// CATEGORIES - Single Source of Truth (Canonical Set)
// =============================================================================
// The complete taxonomy for all merchants. DB is constrained to these values.
// =============================================================================

// The canonical category keys
export type CategoryKey =
  | "Electronics"
  | "Entertainment"
  | "Grocery"
  | "HomeImprovement"
  | "Restaurants"
  | "Shopping"
  | "Specialty"
  | "Travel";

// Human-readable labels
export const CATEGORY_LABELS: Record<CategoryKey, string> = {
  Electronics: "Electronics",
  Entertainment: "Entertainment",
  Grocery: "Grocery",
  HomeImprovement: "Home Improvement",
  Restaurants: "Restaurants",
  Shopping: "Shopping",
  Specialty: "Specialty",
  Travel: "Travel",
};

// All categories for dropdowns (sorted alphabetically)
export const ALL_CATEGORIES: CategoryKey[] = [
  "Electronics",
  "Entertainment",
  "Grocery",
  "HomeImprovement",
  "Restaurants",
  "Shopping",
  "Specialty",
  "Travel",
];

// Get human-readable label
export function getCategoryLabel(category: string | null | undefined): string {
  if (!category) return "Uncategorized";
  return CATEGORY_LABELS[category as CategoryKey] || category;
}
